import {Component} from "@angular/core";
import {ViewController, NavParams, Events} from "ionic-angular";
import * as moment from "moment";
import {ToastService} from "../../core/toast.service";
import {Job} from "../../../pages/job/shared/job.model";
import {JobService} from "../../../pages/job/shared/job.service";

@Component({
  templateUrl: 'job-time-modal.component.html',
})
export class JobTimeModal {
  finished_at: string;
  private job: Job;

  constructor(private viewCtrl: ViewController,
              params: NavParams,
              private jobService: JobService,
              private toast: ToastService,
              private events: Events) {
    this.job = params.get('job');
    this.finished_at = moment(this.job.finished_at ? this.job.finished_at : this.job.ends_at).format(); // Srsly wat
  }

  dismiss() {
    return this.viewCtrl.dismiss();
  }

  save() {
    this.dismiss().then(() => {
      this.jobService.finishJob(
        this.job.id,
        moment(this.finished_at).utc().format())
        .subscribe(
          (res) => {
            this.toast.show(res.message);
            this.events.publish('job:updated');
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/job-time-modal/job-time-modal.component.ts